import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";


const baseURL = process.env.REACT_APP_API_URL;

const getAllPersonas = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/persona/listar?pagina=${page}&cantidadPagina=${perPage}`);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}
const createPersona = async (data) => {
    const response = await api.post(`${baseURL}/persona/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERSONA CREADA', 'La persona se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const deletePersona = async (id) => {
    const response = await api.delete(`${baseURL}/persona/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERSONA ELIMINADA', 'La persona se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const updatePersona = async (data) => {
    const response = await api.put(`${baseURL}/persona/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PERSONA MODIFICADA', 'La persona se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const getPersonaByCedula = async (cedula) => {
    const response = await api.post(`${baseURL}/persona/buscar/cedula`, { cedula });
    if (response.status === 200 || response.status === 201) {
        return response.data;
    } 
}
const personaService = {
    getAllPersonas,
    createPersona,
    deletePersona,
    updatePersona,
    getPersonaByCedula
}

export default personaService;